
import {Component, Prop, Ref, Vue, Watch} from "vue-property-decorator";
import api from "@/api";
import {ElForm} from "element-ui/types/form";
import enums from "@/mixins/filters/enums";
import {
  CreateOrganizationUnitInput,
  OrganizationUnitDto,
  OrganizationUnitLevel, SplitAccountFeeDisplayConfigureDto,
  SplitOrderCycleSettingInput,
  SplitOrderCycleType, SplitReportSettingInput,
  StoreMainType,
  StoreType,
  UpdateOrganizationUnitInput
} from "@/api/appService";
import SimpleImageUpload from "@/components/SimpleImageUpload/index.vue";
import {SelectListItem} from "@/core/common-type-definitions";
import FeeDisplayNamesSetting from "@/views/admin/setting/components/feeDisplayNamesSetting.vue";

@Component({
  components: {SimpleImageUpload},
  mixins: [enums],
  filters: {
    formatCycleValue(value: number): string {
      switch (value) {
        case 1:
          return '周一'
        case 2:
          return '周二'
        case 3:
          return '周三'
        case 4:
          return '周四'
        case 5:
          return '周五'
        case 6:
          return '周六'
        case 0:
          return '周日'
        default:
          return ''
      }
    }
  }
})
export default class OuEdit extends Vue {
  @Ref() ouForm!: ElForm;

  @Prop() item: any;
  @Prop() direction!: string;
  @Prop() level!: any[];

  show = false;

  loading = true;

  cycleExtend = true

  feeDisplaySetting :SplitAccountFeeDisplayConfigureDto = {
    fee1DisplayName: '',
    fee2DisplayName: '',
    fee3DisplayName: ''
  }

  private parentOrg?: OrganizationUnitDto = {};

  defaultData: UpdateOrganizationUnitInput | CreateOrganizationUnitInput = {
    id: 0,
    displayName: undefined,
    isLeaf: false,
    subMchId: '',
    subPayEnable: false,
    level: OrganizationUnitLevel.未分配,
    defaultSplitByPartnership: {},
    defaultSplitByAllianceBusinessSelf: {},
    defaultSplitByJointOperation: {},
    principalName: '',
    storeMainType: undefined,

    detail: {
      desc: undefined,
      logoImgUrl: undefined,
      address: undefined,
      headmanRealName: undefined,
      headmanPhone: undefined,
      businessHour: undefined,
      province: undefined,
      city: undefined,
      cityId: undefined,
      district: undefined,
      lng: undefined,
      lat: undefined
    }
  };

  data:
    | UpdateOrganizationUnitInput
    | CreateOrganizationUnitInput
    | undefined = {...this.defaultData};

  rules = {
    displayName: [
      {
        required: true,
        message: "请输入机构名称",
        trigger: "blur"
      }
    ],
    level: [
      {
        required: true,
        message: "必选",
        trigger: "blur"
      }
    ],
    detail: {
      required: true,
      type: "object",
      fields: {
        logoImgUrl: [
          {
            required: true,
            message: "此项是必须的",
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            message: "地址是必须的",
            trigger: ["blur", "change"]
          }
        ]
      }
    }
  };

  cycleTypes: SelectListItem<string>[] = [
    {value: 'Daily', label: '每天'},
    {value: 'Weekly', label: '每周'},
    {value: 'Monthly', label: '按月'},
    {value: 'Period', label: '固定天数间隔'}
  ]

  monthDays: SelectListItem<number>[] = []

  selectedCycleType: SplitOrderCycleType = SplitOrderCycleType.Period

  currentDetailValue: number | undefined = 1;

  details: number[] = []

  created() {
    for (let i = 1; i <= 28; i++) {
      this.monthDays.push({
        label: i.toString(),
        value: i
      });
    }

    // 获取分账报表——费用显示名称
    api.storeSplitAccountReport.getFeeDisplayNames().then(res => {
      this.feeDisplaySetting = res
    })
  }

  addItem() {
    if (this.details.some(item => item === this.currentDetailValue)) {
      this.$message.error('不能重复添加')
    } else {
      this.details.push(this.currentDetailValue!);
    }
  }

  removeItem(index: number) {
    this.details.splice(index, 1);
  }

  get hasDetails(): boolean {
    return this.details && this.details.length > 0;
  }



  onSelectedCycleTypeChange(newValue: SplitOrderCycleType) {
    this.details = []
    if (newValue === SplitOrderCycleType.Period) {
      this.details = [15];
    } else if (newValue === SplitOrderCycleType.Monthly || newValue === SplitOrderCycleType.Weekly) {
      this.currentDetailValue = 1;
    } else {
      this.currentDetailValue = undefined
    }
  }

  @Watch("item")
  onItemChange(val: any) {
    console.log('onItemChange:', val);
    this.data = {...this.defaultData, ...val};
    if (this.data!.level === '片区') {
      if (!this.data?.defaultSplitByPartnership) {
        this.data!.defaultSplitByPartnership = {}
      }
    }
    if (this.data!.level === OrganizationUnitLevel.门店) {
      this.initializeStore();
    }

    this.selectedCycleType = this.data?.cycleSettingInput?.cycleType ?? SplitOrderCycleType.Period
    this.details = (this.data?.cycleSettingInput?.values ?? '15').split(',').map(i => parseInt(i))

    this.fetchParentOrg()
  }

  private initializeStore() {

    if (this.data!.storeType === StoreType.TongMengSelf) {
      this.data!.subPayEnable = false;
      this.data!.storeMainType = StoreMainType.Company;
      this.data!.principalName = '童萌'
    }


    if (!this.data!.storeSplitSetting) {
      this.$set(this.data!, 'storeSplitSetting', {
        toStore: undefined,
        toTongMeng: undefined,
        toAllianceBusiness: undefined
      })
    }
    if(this.data?.cycleSettingInput){
      debugger
      this.cycleExtend = false
    }


  }

  private handleClose() {
    this.$confirm("确认关闭？")
      .then(_ => {
        this.show = false;
      })
      .catch(_ => {
      });
  }

  private fetchParentOrg() {
    console.log('fetchParentOrg:', this.data)
    let currentOrg = this.data as OrganizationUnitDto;
    if (currentOrg.parentId) {
      api.organizationUnit.getOrganizationUnit({id: currentOrg.parentId}).then(org => {
        this.parentOrg = {...org};

        this.loading = false

        const defaultSplitByPartnership = {
          toStore: 100,
          toAllianceBusiness: 0,
          toTongMeng: 0
        }
        const defaultSplitByAllianceBusinessSelf = {
          toStore: 100,
          toAllianceBusiness: 0,
          toTongMeng: 0,
        }
        const defaultSplitByJointOperation = {
          toStore: 70,
          toAllianceBusiness: 20,
          toTongMeng: 10
        }

        this.parentOrg = {
          ...{
            defaultSplitByPartnership,
            defaultSplitByAllianceBusinessSelf,
            defaultSplitByJointOperation
          }, ...this.parentOrg
        }
        if (!this.parentOrg.defaultSplitByPartnership) {
          this.parentOrg.defaultSplitByPartnership = defaultSplitByPartnership
        }
        if (!this.parentOrg.defaultSplitByJointOperation) {
          this.parentOrg.defaultSplitByJointOperation = defaultSplitByJointOperation
        }
        if (!this.parentOrg.defaultSplitByAllianceBusinessSelf) {
          this.parentOrg.defaultSplitByAllianceBusinessSelf = defaultSplitByAllianceBusinessSelf
        }

      })
    } else {
      this.parentOrg = {}
    }
  }

  /**
   * 上级机构是否为共建机构
   */
  get isParentOrgOfAllianceBusiness() {
    console.log('isParentOrgOfAllianceBusiness entry')
    if (this.parentOrg) {
      console.log('isParentOrgOfAllianceBusiness parentOrg:', this.parentOrg)
      return this.parentOrg.level === OrganizationUnitLevel.片区 && this.parentOrg.isAllianceBusiness;
    } else {
      return false;
    }
  }

  private handleSave() {
    this.ouForm.validate(valid => {
      if (valid) {
        this.$confirm("你确定提交修改吗?")
          .then(_ => {
            // ok
            this.data!.cycleSettingInput = {
              cycleType: this.selectedCycleType,
              values: this.details.join(',')
            } as SplitOrderCycleSettingInput

            if(this.cycleExtend){
              this.data!.cycleSettingInput = undefined
            }

            let fn;
            if (this.data!.id)
              fn = api.organizationUnit.updateOrganizationUnit({
                body: this.data!
              });
            else
              fn = api.organizationUnit.createOrganizationUnit({
                body: this.data!
              });
            fn.then(res => {
              this.show = false;
              this.$emit("update");
              this.$message({
                type: "success",
                message: "修改成功"
              });
            });
            // ok end
          })
          .catch(_ => {
          });
      }
    });
  }

  private async handleSelect(e: any) {
    this.data!.detail!.city = e.city;
    this.data!.detail!.cityId = e.cityId;
    this.data!.detail!.province = e.province;
    this.data!.detail!.district = e.district;
    this.data!.detail!.lat = e.lat;
    this.data!.detail!.lng = e.lng;
  }

  private async querySearch(queryString: string, callback: Function) {
    api.client.getPlaceSuggestion({query: queryString}).then(res => {
      const list: any[] = [];
      res.forEach(x => {
        list.push(
          Object.assign(
            {
              value: x.district + " " + x.name,
              address: x.name
            },
            x
          )
        );
      });
      console.log(list);
      callback(list);
    });
  }


  onStoreTypeChange(storeType: string) {
    if (storeType === 'TongMengSelf') {
      this.data!.subPayEnable = false;
      this.data!.storeMainType = StoreMainType.Company;
      this.data!.principalName = '童萌'
    } else {
      this.data!.subPayEnable = true;
      if (!this.data!.subMchId) {
        this.data!.subMchId = ''
      }

    }
  }

  onSubPayEnableChange(enabled: boolean) {
    if (enabled) {
      this.data!.subMchId = '';
      this.data!.storeMainType = StoreMainType.Company;
      if (!this.data!.principalName) {
        this.data!.principalName = '童萌'
      }

    }
  }

  get splitFeeSetting():SplitReportSettingInput{
    if(!this.data!.splitFeeSetting){
      this.data!.splitFeeSetting = {
        fee1:0,
        fee2:0,
        fee3:0,
        splitPercentOfPartialArea:undefined,
        splitPercentOfStore: undefined
      }
    }

    return this.data?.splitFeeSetting!;


  }

  get parentSplitSetting() {
    if (!this.parentOrg!.defaultSplitByAllianceBusinessSelf) {
      this.parentOrg!.defaultSplitByAllianceBusinessSelf = {
        toAllianceBusiness: 0,
        toTongMeng: 0,
        toStore: 0,
      }
    }
    if (!this.parentOrg!.defaultSplitByPartnership) {
      this.parentOrg!.defaultSplitByPartnership = {
        toAllianceBusiness: 0,
        toStore: 0,
        toTongMeng: 0
      }
    }
    if (!this.parentOrg!.defaultSplitByJointOperation) {
      this.parentOrg!.defaultSplitByJointOperation = {
        toAllianceBusiness: 10,
        toTongMeng: 0,
        toStore: 0
      }
    }

    return this.parentOrg;

  }


  get defaultSplitByPartnership() {
    if (this.data?.defaultSplitByPartnership) {
      return this.data.defaultSplitByPartnership;
    } else {
      this.data!.defaultSplitByPartnership = {}
      return this.data?.defaultSplitByPartnership;
    }
  }

  get defaultSplitByAllianceBusinessSelf() {
    if (this.data?.defaultSplitByAllianceBusinessSelf) {
      return this.data.defaultSplitByAllianceBusinessSelf;
    } else {
      this.data!.defaultSplitByAllianceBusinessSelf = {}
      return this.data?.defaultSplitByAllianceBusinessSelf;
    }
  }


  get defaultSplitByJointOperation() {
    if (this.data?.defaultSplitByJointOperation) {
      return this.data.defaultSplitByJointOperation;
    } else {
      this.data!.defaultSplitByJointOperation = {}
      return this.data?.defaultSplitByJointOperation;
    }
  }


}
